module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-carsharing-und-oev-056a1f5398a976735bdaca24ce611acc.svg";